export const GET_CREDIT_USAGE = "GET-CREDIT-USAGE";
export const GET_EXECUTION_HISTORY = "GET-EXECUTION-HISTORY";
export const GET_ALL_SUBSCRIPTION_PLANS = "GET-ALL-SUBSCRIPTION-PLANS";
export const GET_EXECUTION_ANALYTICS = "GET-EXECUTION-ANALYTICS";
export const GET_WALLET = "GET-WALLET";
export const GET_TOKEN_USAGE = "GET-TOKEN-USAGE";
